export default __webpack_public_path__ + "static/media/NeurialGrotesk.f098bf5e.woff2";